// Drill-down navigation: keep block height equal to current active UL.
// If none is active, use the first UL of the block.

document.querySelectorAll(".wp-block-ergosign-drill-down-navigation").forEach((block) => {
    const nav = block.querySelector("nav") as HTMLElement | null;

    const getCurrentList = (): HTMLElement | null => {
        const active = block.querySelector(
            ".wp-block-drill-down-navigation__submenu-container.is-active"
        ) as HTMLElement | null;
        if (active) return active;
        // Prefer the top-level UL inside the nav
        const top = block.querySelector("nav > ul") as HTMLElement | null;
        if (top) return top;
        // Fallback to any UL in the block
        return block.querySelector("ul");
    };

    const updateHeight = () => {
        if (!nav) return;
        const current = getCurrentList();
        if (!current) return;
        // Use scrollHeight first to get full content height.
        // Avoid setting to 0 when the block is inside a hidden container.
        const h = Math.max(current.scrollHeight, current.offsetHeight);
        if (h > 0) {
            nav.style.height = h + "px";
        }
    };

    // Initialize height on load (will skip if hidden and height is 0)
    updateHeight();

    // Update when the nav becomes visible (e.g., accordion expands)
    if (nav && "IntersectionObserver" in window) {
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // Delay to allow layout to settle
                        requestAnimationFrame(updateHeight);
                    }
                });
            },
            { threshold: 0.01 }
        );
        io.observe(nav);
    }

    // Update on window resize
    window.addEventListener("resize", updateHeight);

    // Handle forward navigation into submenu
    block.querySelectorAll(".has-child > a").forEach((el) => {
        el.addEventListener("click", (event) => {
            event.preventDefault();
            const submenu = (el as HTMLElement).nextElementSibling as HTMLElement | null;
            //console.log(1, (el as HTMLElement).parentElement.parentElement,  submenu, submenu.classList)
            if (!submenu) return;
            submenu.classList.toggle("is-active");
            // Wait for layout to update before measuring
            requestAnimationFrame(updateHeight);
        });
    });

    // Handle back buttons inside submenus
    block
        .querySelectorAll(".wp-block-ergosign-drill-down-navigation__back")
        .forEach((btn: Element) => {
            btn.addEventListener("click", (event) => {
                event.preventDefault();

                // Remove is-active from ALL submenus
                block.querySelectorAll(".is-active").forEach((el) => {
                    el.classList.remove("is-active");
                });

                // Remove from the clicked submenu
                const submenu = btn.closest(".submenu-selector") as HTMLElement | null;
                if (submenu) {
                    submenu.classList.remove("is-active");
                }

                requestAnimationFrame(updateHeight);
            });
        });
});
